import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-address-cell-renderer",
  templateUrl: "./address-cell-renderer.component.html",
  styleUrls: ["./address-cell-renderer.component.scss"],
})
export class AddressCellRendererComponent implements OnDestroy{
  params;
  address: string;
  linkAddress: string;
  private destroy$ = new Subject<void>();
  constructor() {}

  agInit(params): void {
    this.params = params;
    this.address = `${this.params.data.Address1 ? this.params.data.Address1: ""} ${this.params.data.Address2 ? this.params.data.Address2 : ""} ${
      this.params.data.City ? this.params.data.City : ""
    } ${this.params.data.State ? this.params.data.State : ""} ${
      this.params.data.Postal ? this.params.data.Postal : ""
    } ${this.params.data.Country ? this.params.data.Country : ""}`;
    this.address = this.address.trim();
    if (this.address) {
      this.linkAddress = `https://www.google.com/maps/place/${this.address}`;
    }
  }

  openMaps() {
    window.open(this.linkAddress);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
